// extracted by mini-css-extract-plugin
export var deleteIcon = "_qb-5";
export var deleteOption = "_qb-3";
export var divider = "_qb-2";
export var downloadIcon = "_qb-4";
export var drawer = "_qb-0";
export var drawerFooter = "_qb-6";
export var drawerOpen = "_qb-1";
export var highlighted = "_qb-7";
export var lighterHighlight = "_qb-8";